
exports.hookPageid = function($){
    $.ajaxPrefilter( "*", function( s) {
        var dmtrack_pageid = window.dmtrack_pageid;
        var url = s.url;
        if(dmtrack_pageid &&
            /(\?|&)dmtrack_pageid=/.test(url) === false){
            url += ( /\?/.test( url ) ? '&' : '?' ) + 'dmtrack_pageid=' + dmtrack_pageid;
        }
        s.url = url;
    });
};
